namespace $ {

	export class $shm_hitalama_text_images extends $giper_baza_entity.with({
		Markdown_images: $giper_baza_list_link.to( ()=> $giper_baza_file ),
	}) {

		private static allocations = new WeakMap< object, Map< string, $shm_hitalama_text_images_file > >()

		static allocate( owner: $giper_baza_entity, operation: object, index: number ) {
			let files = this.allocations.get( operation )
			if( !files ) this.allocations.set( operation, files = new Map )
			const key = owner.link().str + ':' + index
			let image = files.get( key )
			if( !image ) {
				image = owner.land().area_make().Data( $shm_hitalama_text_images_file )
				files.set( key, image )
			}
			return image
		}

		@ $mol_action
		static attach( owner: $giper_baza_entity, source: File, bytes: Uint8Array< ArrayBuffer >, operation: object, index: number ) {
			if( !owner.can_change() ) throw new Error( 'Нет прав на добавление изображения.' )
			if( !source.size || !source.type.startsWith( 'image/' ) ) throw new Error( 'В буфере нет непустого изображения. Скопируйте картинку и повторите вставку.' )
			if( bytes.byteLength !== source.size ) throw new Error( 'Изображение прочитано не полностью. Повторите вставку.' )
			const image = $mol_wire_sync( this ).allocate( owner, operation, index )
			if( image.Byte_size()?.val() !== source.size ) {
				image.buffer( bytes )
				image.type( source.type )
				image.name( source.name )
				image.Byte_size( null )!.val( source.size )
			}
			owner.cast( this ).Markdown_images( null )!.add( image.link() )
			return `?BAZA:file=${ image.link().str };name=image.png`
		}

		@ $mol_mem_key
		private static pending( link: string ) { return new $mol_promise_blocker<void>() }

		@ $mol_mem_key
		static resource( link: string ) {
			const file = $giper_baza_glob.Pawn( new $giper_baza_link( link ), $shm_hitalama_text_images_file )
			$shm_hitalama_map_component_ready.read( file )
			const size = file.Byte_size()?.val()
			const chunks = file.chunks()
			if( !file.Type()?.val() || !file.Chunks() || size === undefined || chunks.reduce( ( sum, chunk )=> sum + chunk.length, 0 ) !== size ) {
				$mol_fail_hidden( this.pending( link ) )
			}
			if( !file.type().startsWith( 'image/' ) ) throw new Error( 'Вложение не является изображением.' )
			const resource = new $mol_object
			const uri = URL.createObjectURL( file.blob() )
			resource.destructor = ()=> URL.revokeObjectURL( uri )
			return Object.assign( resource, { uri: uri + '#image.png' } )
		}

	}

}
